import React from 'react';

export default function Input({ label, value, onChange, type = 'text', placeholder, required, icon, style, error, name }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && (
        <label style={{ fontSize: 12, fontWeight: 600, color: '#334155', letterSpacing: '0.01em' }}>
          {label}{required && <span style={{ color: '#EF4444', marginLeft: 3 }}>*</span>}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {icon && (
          <span style={{
            position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
            color: '#94A3B8', display: 'flex', alignItems: 'center', pointerEvents: 'none',
          }}>{icon}</span>
        )}
        <input
          type={type} value={value} onChange={onChange} placeholder={placeholder} name={name}
          style={{
            width: '100%',
            padding: icon ? '10px 14px 10px 38px' : '10px 14px',
            border: `1.5px solid ${error ? '#EF4444' : '#E2E8F0'}`,
            borderRadius: 10,
            fontSize: 13,
            color: '#0F172A',
            background: '#fff',
            outline: 'none',
            fontFamily: 'inherit',
            transition: 'border-color 0.2s, box-shadow 0.2s',
            lineHeight: 1.5,
          }}
          onFocus={e => {
            e.target.style.borderColor = error ? '#EF4444' : '#00CEEE';
            e.target.style.boxShadow = error ? '0 0 0 3px rgba(239,68,68,0.1)' : '0 0 0 3px rgba(0,206,238,0.1)';
          }}
          onBlur={e => {
            e.target.style.borderColor = error ? '#EF4444' : '#E2E8F0';
            e.target.style.boxShadow = 'none';
          }}
        />
      </div>
      {error && <span style={{ fontSize: 11, color: '#EF4444', fontWeight: 500 }}>{error}</span>}
    </div>
  );
}

export function Select({ label, value, onChange, options = [], required, style, placeholder }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && (
        <label style={{ fontSize: 12, fontWeight: 600, color: '#334155', letterSpacing: '0.01em' }}>
          {label}{required && <span style={{ color: '#EF4444', marginLeft: 3 }}>*</span>}
        </label>
      )}
      <select value={value} onChange={onChange} style={{
        width: '100%',
        padding: '10px 14px',
        border: '1.5px solid #E2E8F0',
        borderRadius: 10,
        fontSize: 13,
        color: '#0F172A',
        background: '#fff',
        outline: 'none',
        fontFamily: 'inherit',
        cursor: 'pointer',
        transition: 'border-color 0.2s, box-shadow 0.2s',
        lineHeight: 1.5,
        appearance: 'none',
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'%3E%3C/path%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        paddingRight: 36,
      }}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}

export function Textarea({ label, value, onChange, placeholder, rows = 3, style }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && <label style={{ fontSize: 12, fontWeight: 600, color: '#334155' }}>{label}</label>}
      <textarea
        value={value} onChange={onChange} placeholder={placeholder} rows={rows}
        style={{
          width: '100%',
          padding: '10px 14px',
          border: '1.5px solid #E2E8F0',
          borderRadius: 10,
          fontSize: 13,
          color: '#0F172A',
          background: '#fff',
          outline: 'none',
          fontFamily: 'inherit',
          resize: 'vertical',
          transition: 'border-color 0.2s, box-shadow 0.2s',
          lineHeight: 1.5,
        }}
        onFocus={e => {
          e.target.style.borderColor = '#00CEEE';
          e.target.style.boxShadow = '0 0 0 3px rgba(0,206,238,0.1)';
        }}
        onBlur={e => {
          e.target.style.borderColor = '#E2E8F0';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
  );
}
